import * as FaIcons from 'react-icons/fa'

export const SocialList = [
    {
        title: 'Facebook',
        path: 'https://www.facebook.com/profile.php?id=100093448566259',
        cName: 'social-list',
        icon: <FaIcons.FaFacebook color="#fff" size={30} />,
    },
    {
        title: 'Instagram',
        path: 'https://www.instagram.com/luneaetcoconut/',
        cName: 'social-list',
        icon: <FaIcons.FaInstagram color="#fff" size={30} />,
    },
]
